import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'

import { ThemeProvider } from 'context/ThemeContext'
import CustomCursor from 'components/CustomCursor'

import './i18n'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <ThemeProvider>
    <CustomCursor />
    <App />
  </ThemeProvider>
)
